"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var CoreServiceHelper_1 = require("./CoreServiceHelper");
var FormProviderImpl = (function () {
    function FormProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.COLLECTION = 'form';
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " NotificationServiceImpl#")], args, false));
            }
        };
        this.log('FormServiceImpl# created!');
    }
    FormProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    FormProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    FormProviderImpl.prototype.stopAllMonitor = function () {
    };
    FormProviderImpl.prototype.createForm = function (form) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createData(this.COLLECTION, form);
    };
    FormProviderImpl.prototype.getForm = function (id) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(this.COLLECTION, { _id: id }, {}, {}, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    FormProviderImpl.prototype.getForms = function () {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData(this.COLLECTION, {}, {}, {}, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    FormProviderImpl.prototype.removeForm = function (form) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).removeData(this.COLLECTION, { _id: form._id });
    };
    FormProviderImpl.prototype.updateForm = function (form) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).updateData(this.COLLECTION, { _id: form._id }, form);
    };
    FormProviderImpl.prototype.createRegistration = function (registration) {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).createData('course_registration', registration);
    };
    FormProviderImpl.prototype.getRegistrations = function (filter, sort) {
        var _this = this;
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('course_registration', filter, sort, {}, undefined)
            .then(function (response) {
            return Promise.resolve(response.result ? response.result : []);
        })
            .catch(function (err) {
            _this.log(err);
            return Promise.resolve([]);
        });
    };
    return FormProviderImpl;
}());
exports.FormProviderImpl = FormProviderImpl;
//# sourceMappingURL=FormProviderImpl.js.map